import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../../Api/Api";
import Skltn from "./skltnDetails";
import Cookies from "universal-cookie";

const ArchiveDetail = (props) => {
  const [state, setState] = useState({
    data: null,
    loader: true,
    awards: null,
  });
  const cookies = new Cookies();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (cookies.get("api_key") == null) {
      props.history.push(`/Entrance`);
    }

    base_url
      .get(`lottery/${props.match.params.id}`)
      .then((response) => {
        var items = response.data.lottert.awards;

        items.sort(function (a, b) {
          return a.rank - b.rank;
        });

        setState({
          ...state,
          data: response.data.lottert,
          awards: items,
          loader: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  }, []);

  return (
    <React.Fragment>
      {state.data == null ? (
        <Skltn />
      ) : (
        <div className="archive-detail">
          <div className="contain">
            <div className="awardDetails">
              <div className="backward">
                <span onClick={() => props.history.goBack()}>
                  بازگشت{" "}
                  <i className="icon-arrow-down-sign-to-navigate-fill"></i>
                </span>
              </div>
              <div className="detailBody">
                <div className="details">
                  <div className="title">
                    <span>{state.data == null ? null : state.data.title}</span>
                  </div>
                  <h5>جزئیات قرعه کشی</h5>
                  <p>{state.data == null ? null : state.data.description}</p>
                  <h5>جوایز برندگان</h5>
                  {state.data == null ? (
                    <span className="no-content">اطلاعاتی وجود ندارد</span>
                  ) : state.awards.length == 0 ? (
                    <span className="no-content">اطلاعاتی وجود ندارد</span>
                  ) : (
                    <div className="list-winner">
                      {state.awards.map((item) =>
                        item.user == null ? (
                          <span className="winner">
                            <span>{item.title}</span>
                            <span>{item.description}</span>
                          </span>
                        ) : (
                          <div className="winners">
                            <div className="user-pic">
                              <img src={item.user.profile_photo_url} />
                            </div>
                            <div className="winner-detail">
                              <span>
                                {item.user.name} {item.user.last_name}
                              </span>
                              <span>{item.description}</span>
                            </div>
                            <div className="award-icon">
                              <div className="grade-user">
                                <img src="/icons/Group 11800.svg" />
                                <span>{item.rank}</span>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ArchiveDetail;
